import { Injectable } from '@angular/core';
import { IElementDetailsSortByInputModel } from 'src/app/ViewModel/ElementDetailsModel';
import { ElementDetailsLinkSaveModel } from 'src/app/ViewModel/ElementsDetailsLinkSaveModel';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
	providedIn: 'root'
})
export class ElementDetailsLinkService {

	private getDependentElementsUrl = 'ElementLink/GetProjectDependantDocumentElement';
	private saveElementsDetailsLinkUrl = 'ElementDetailsLink/PostProjectDocumentElementDetails';
	private updateElementDetailsSortByUrl = 'ElementDetailsLink/UpdateProjectElementDetailsSortBy';

	constructor(private commonService: CommonService,
		private restApiService: RestApiService,) { }

	getDependentElements(projectId: number, groupId: string, moduleId: string|null, parentElementId: number|null) {
		return this.restApiService.new_POST(this.getDependentElementsUrl, { projectId, groupId, moduleId, parentElementId });
	}


	saveElementsDetailsLink(reqData: ElementDetailsLinkSaveModel) {
		return this.restApiService.new_POST(this.saveElementsDetailsLinkUrl, reqData);
	}

	updateElementDetailsSortby(elementDetailsOrderBy: IElementDetailsSortByInputModel) {
		return this.restApiService.new_POST(this.updateElementDetailsSortByUrl, elementDetailsOrderBy);
	}

}
